import { IDepartment } from '../../../lib/types';
import { ICompanyDepartmentsResult } from './department.types';
import { GET_COMPANY_DEPARTMENTS } from './department.queries';
import { IApolloCacheParams } from '../../../lib/cache.types';
import { mergeCacheLists } from '../../../lib/utils';
import { IArchivableProps } from '../../../lib/query.types';

export const updateDepartmentInCache = ({
  cache,
  department,
  remove
}: IApolloCacheParams & { department: IDepartment; remove?: boolean }) => {
  const currCompanyDepartments =
    cache.readQuery<ICompanyDepartmentsResult, IArchivableProps>({
      query: GET_COMPANY_DEPARTMENTS,
      variables: { includeArchived: true }
    })?.departments ?? [];

  cache.writeQuery<ICompanyDepartmentsResult, IArchivableProps>({
    query: GET_COMPANY_DEPARTMENTS,
    data: {
      departments: remove
        ? currCompanyDepartments.filter((d) => d._id !== department._id)
        : mergeCacheLists(currCompanyDepartments, [department])
    },
    variables: { includeArchived: true },
    overwrite: true
  });
};
